<h1 mat-dialog-title>Aggiornamento isin {{isinData.isin}}</h1>
<div mat-dialog-content>
  <form [formGroup]="form">
    <mat-form-field>
      <mat-label>Quantità</mat-label>
      <input type="number" formControlName="amount" min="1" matInput>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Prezzo Certificato</mat-label>
      <input type="string" formControlName="price" matInput>
      <mat-error *ngIf="form.get('price').hasError('pattern')">
        {{ isValidPrice()
          ? 'Utilizzare il punto come separatore decimale nell\'importo'
          : 'Inserire un prezzo maggiore di 0' }}
      </mat-error>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Data</mat-label>
      <input matInput [matDatepicker]="picker" formControlName="date" readonly>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker disabled="false"></mat-datepicker>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onYesClick()" [disabled]="form.invalid">Aggiorna</button>
  <button mat-button (click)="onNoClick()">Annulla</button>
</div>
